// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import Qs from 'qs'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

axios.defaults.baseURL = '//app.shiminjia.com'
axios.defaults.withCredentials = true;

// const cache = localStorage['user'];
// if (cache) {
//   const user = JSON.parse(cache);
//   if (user) {
//     const instance = axios.create({
//       headers: {
//         TOKEN: user.token, // 设置 Authorization
//         TIMESTAMP: user.timestamp
//       },
//     });
//     Vue.prototype.$axios = instance;
//   }
// } else {
//   Vue.prototype.$axios = axios;
// }
Vue.prototype.$axios = axios;
Vue.config.productionTip = false

Vue.prototype.qs = Qs;
/* eslint-disable no-new */

Vue.use(ElementUI);
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js